// @flow

import type { Dict } from '../../types/dict';

export const required = (errorMessage: string) => (
  (value: string): ?string => (
    value
      ? undefined
      : (errorMessage || 'Required')
  )
);

export const requiredNumber = (errorMessage: string) => (
  (value: number): ?string => (
    value !== null
      ? undefined
      : (errorMessage || 'Required')
  )
);

export const requiredMultiField = (errorMessage: string) => (
  (fields: Array<string>) => (
    (values: Dict<string>): ?string => {
      if (values && fields.every(field => required(errorMessage)(values[field]) === undefined)) {
        return undefined;
      }

      return errorMessage || 'Required';
    }
  )
);
